import React from 'react'
import styles from './styles.module.scss'

import RestoGuideIcon from "./assets/RestoGuideIcon.tsx"
import RestoGuideIconKz from './assets/RestoGuideIconKz.tsx'
import BlogIcon from './assets/BlogIcon.tsx'
import WebinarIcon from './assets/WebinarIcon.tsx'
import SupportIcon from './assets/SupportIcon.tsx'
import {
  externalLinks,
  pagesLinks,
} from '../../../pages-data/_V2/common/links.ts'

import { Locales } from "../../../localization/types"
import classNames from "classnames";

export const getData = (locale: Locales) => {
  if (locale === 'ru-BY'){
    return {
      label: 'База знаний',
      title: 'Для всех\nпервооткрывателей',
      description: (
          <>
            С нами открылись более 10 000&nbsp;заведений в СНГ.
            Мы&nbsp;собрали лучшие практики и&nbsp;материалы
            для начинающих рестораторов в нашей
            «Базе знаний». Запускай бизнес уверенно!
          </>
      ),
      items: [
        {
          icon: <RestoGuideIconKz className={classNames(styles.knowledgeBaseItem__icon, styles.knowledgeBaseItem__icon__kz)}/>,
          text: 'Справочник\nресторатора',
          link: {
            ...pagesLinks.restoGuide,
            target: '_blank'
          },
        },
        {
          icon: <BlogIcon className={styles.knowledgeBaseItem__icon} />,
          text: 'Медиа проект \n «Котёл»',
          link: {
            ...pagesLinks.blog,
            target: '_blank'
          },
        },
        {
          icon: <WebinarIcon className={styles.knowledgeBaseItem__icon} />,
          text: 'Обучающие\nвебинары',
          link: {
            href: externalLinks.webinars,
            target: '_blank'
          },
        },
        {
          icon: <SupportIcon className={styles.knowledgeBaseItem__icon} />,
          text: 'Раздел\nтехподдержки',
          link: {
            href: `${externalLinks.quickrestoRU.href}${pagesLinks.support.href.slice(1)}`,
            useGatsbyLink: false,
            target: '_blank'
          },
        },
      ],
    }
  }
  if (locale === 'ru-KZ') {
    return {
      label: 'База знаний',
      title: "Для тех, \nкто открывается",
      description: (
          <>
            С нами открылись более 10 000 заведений в СНГ. Мы&nbsp;собрали лучшие практики и&nbsp;материалы для начинающих рестораторов в&nbsp;нашей «Базе знаний». Открывайся уверенно!
          </>
      ),
      items: [
        {
          icon: <RestoGuideIconKz className={classNames(styles.knowledgeBaseItem__icon, styles.knowledgeBaseItem__icon__kz)}/>,
          text: 'Гид\nресторатора',
          link:  {
            ...pagesLinks.restoGuide,
            target: '_blank'
          },
        },
        {
          icon: <BlogIcon className={styles.knowledgeBaseItem__icon} />,
          text: 'Медиа проект\n«Котёл»',
          link: {
            ...pagesLinks.blog,
            target: '_blank'
          },
        },
        {
          icon: <WebinarIcon className={styles.knowledgeBaseItem__icon} />,
          text: 'Обучающие\nвебинары',
          link: {
            href: externalLinks.webinars,
            target: '_blank'
          },
        },
        {
          icon: <SupportIcon className={styles.knowledgeBaseItem__icon} />,
          text: 'Раздел\nтехподдержки',
          link: {
            href: `${externalLinks.quickrestoRU.href}${pagesLinks.support.href.slice(1)}`,
            useGatsbyLink: false,
            target: '_blank'
          },
        },
      ],
    }
  }

  return {
    label: 'База знаний',
    title: 'Для всех\nпервооткрывателей',
    description: (
        <>
          С нами открылись более 10 000 заведений в СНГ. Мы&nbsp;собрали
          лучшие практики и&nbsp;материалы для начинающих рестораторов в&nbsp;нашей
          &laquo;Базе знаний&raquo;. Открывайтесь уверенно!
        </>
    ),
    items: [
      {
        icon: <RestoGuideIcon className={styles.knowledgeBaseItem__icon} />,
        text: 'Гид\nресторатора',
        link: pagesLinks.restoGuide,
      },
      {
        icon: <BlogIcon className={styles.knowledgeBaseItem__icon} />,
        text: 'Блог\nQuick Resto',
        link: pagesLinks.blog,
      },
      {
        icon: <WebinarIcon className={styles.knowledgeBaseItem__icon} />,
        text: 'Обучающие\nвебинары',
        link: {
          href: externalLinks.webinars,
        },
      },
      {
        icon: <SupportIcon className={styles.knowledgeBaseItem__icon} />,
        text: 'Раздел\nтехподдержки',
        link: pagesLinks.support,
      },
    ],
  }
}
